export default "__VITE_ASSET__cGcYOeH___"